// src/pages/CalculoHonorarios/components/PonderacoesFinais.js

import React from 'react';

const PonderacoesFinais = ({ formData, onChange }) => {
  return (
    <div className="formulario-secao">
      <h3>📊 Parte 3 — Ponderações Finais</h3>

      <div className="form-group">
        <label className="field-label">
          <span>🎯</span>
          Resultado Obtido
        </label>
        <textarea
          value={formData.resultados_obtidos || ''}
          onChange={(e) => onChange('resultados_obtidos', e.target.value)}
          placeholder="Descreva o resultado do trabalho e sucessos obtidos..."
          className="form-textarea"
          rows="4"
        />
      </div>

      <div className="form-group">
        <label className="field-label">
          <span>💳</span>
          Condição Econômica do Cliente
        </label>
        <select
          value={formData.condicoes_economicas || ''}
          onChange={(e) => onChange('condicoes_economicas', e.target.value)}
          className="form-input"
        >
          <option value="">Selecionar...</option>
          <option value="Alta Renda">Alta Renda</option>
          <option value="Normal">Normal</option>
          <option value="Baixa Renda">Baixa Renda</option>
          <option value="N/A">N/A</option>
        </select>
      </div>

      <div className="form-group">
        <label className="field-label">
          <span>💡</span>
          Orientações Adicionais
        </label>
        <textarea
          value={formData.orientacoes_adicionais || ''}
          onChange={(e) => onChange('orientacoes_adicionais', e.target.value)}
          placeholder="Descreva orientações adicionais para cálculo de justificativa dos honorários...
Exemplos:
- O que não considerar
- Alterações após primeira resposta..."
          className="form-textarea"
          rows="4"
        />
      </div>
    </div>
  );
};

export default PonderacoesFinais;